import * as i0 from '@angular/core';
import { Injectable, Directive, Component, Input, ViewChild, EventEmitter, Output, NgModule } from '@angular/core';
import * as i5 from '@angular/material/sort';
import { MatSort, MatSortModule } from '@angular/material/sort';
import * as i6 from '@angular/material/paginator';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import * as i2 from '@angular/material/dialog';
import { MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import '@angular/cdk/table';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import * as i7 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i8 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
function TableCellComponent_ng_template_0_Template(rf, ctx) {}
const _c0 = a0 => [a0];
function DynamicTableComponent_ng_container_1_th_1_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function DynamicTableComponent_ng_container_1_th_1_button_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const column_r2 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.filter(column_r2);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementStart(1, "mat-icon", 11);
    i0.ɵɵtext(2, "filter_list");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const column_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r2.getFilterDescription(column_r2));
    i0.ɵɵpropertyInterpolate("matTooltipDisabled", !ctx_r2.getFilterDescription(column_r2));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("color", ctx_r2.isFiltered(column_r2) ? "primary" : "default");
  }
}
function DynamicTableComponent_ng_container_1_th_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 8);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, DynamicTableComponent_ng_container_1_th_1_button_2_Template, 3, 3, "button", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("mat-sort-header", column_r2.name);
    i0.ɵɵproperty("disabled", column_r2.sort === false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", column_r2.displayName, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showFilters && ctx_r2.canFilter(column_r2));
  }
}
function DynamicTableComponent_ng_container_1_td_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 12);
    i0.ɵɵelement(1, "mdt-table-cell", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r4 = ctx.$implicit;
    const column_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("row", row_r4)("column", column_r2);
  }
}
function DynamicTableComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 5);
    i0.ɵɵtemplate(1, DynamicTableComponent_ng_container_1_th_1_Template, 3, 4, "th", 6)(2, DynamicTableComponent_ng_container_1_td_2_Template, 2, 2, "td", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const column_r2 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("matColumnDef", column_r2.name);
    i0.ɵɵproperty("sticky", column_r2.sticky === "start")("stickyEnd", column_r2.sticky === "end");
  }
}
function DynamicTableComponent_tr_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 14);
  }
}
function DynamicTableComponent_tr_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 15);
    i0.ɵɵlistener("click", function DynamicTableComponent_tr_3_Template_tr_click_0_listener() {
      const row_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onRowClick(row_r6));
    });
    i0.ɵɵelementEnd();
  }
}
class ColumnFilter {}
let ColumnFilterService = /*#__PURE__*/(() => {
  class ColumnFilterService {
    constructor() {
      this.registeredFilters = {};
    }
    registerFilter(type, component) {
      this.registeredFilters[type] = component;
    }
    getFilter(type) {
      const component = this.registeredFilters[type];
      return component;
    }
  }
  /** @nocollapse */
  /** @nocollapse */ColumnFilterService.ɵfac = function ColumnFilterService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ColumnFilterService)();
  };
  ColumnFilterService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ColumnFilterService,
    factory: ColumnFilterService.ɵfac
  });
  return ColumnFilterService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CellDirective = /*#__PURE__*/(() => {
  class CellDirective {
    constructor(viewContainerRef) {
      this.viewContainerRef = viewContainerRef;
    }
  }
  /** @nocollapse */
  /** @nocollapse */CellDirective.ɵfac = function CellDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CellDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef));
  };
  CellDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CellDirective,
    selectors: [["", "mdtCellHost", ""]],
    standalone: false
  });
  return CellDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ColumnConfig {}
let TextCellComponent = /*#__PURE__*/(() => {
  class TextCellComponent {}
  /** @nocollapse */
  /** @nocollapse */TextCellComponent.ɵfac = function TextCellComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TextCellComponent)();
  };
  TextCellComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TextCellComponent,
    selectors: [["mdt-text-cell"]],
    inputs: {
      column: "column",
      row: "row"
    },
    standalone: false,
    decls: 1,
    vars: 1,
    template: function TextCellComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtext(0);
      }
      if (rf & 2) {
        i0.ɵɵtextInterpolate(ctx.row[ctx.column.name]);
      }
    },
    encapsulation: 2
  });
  return TextCellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CellService = /*#__PURE__*/(() => {
  class CellService {
    constructor() {
      this.registeredCells = {};
    }
    registerCell(type, component) {
      this.registeredCells[type] = component;
    }
    getCell(type) {
      const component = this.registeredCells[type];
      if (component == null) {
        return TextCellComponent;
      }
      return component;
    }
  }
  /** @nocollapse */
  /** @nocollapse */CellService.ɵfac = function CellService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CellService)();
  };
  CellService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CellService,
    factory: CellService.ɵfac
  });
  return CellService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TableCellComponent = /*#__PURE__*/(() => {
  class TableCellComponent {
    constructor(cellService, componentFactoryResolver) {
      this.cellService = cellService;
      this.componentFactoryResolver = componentFactoryResolver;
    }
    ngOnInit() {
      this.initCell();
    }
    initCell() {
      const cellComponent = this.cellService.getCell(this.column.type);
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(cellComponent);
      const viewContainerRef = this.cellHost.viewContainerRef;
      viewContainerRef.clear();
      const componentRef = viewContainerRef.createComponent(componentFactory);
      const cell = componentRef.instance;
      cell.row = this.row;
      cell.column = this.column;
    }
  }
  /** @nocollapse */
  /** @nocollapse */TableCellComponent.ɵfac = function TableCellComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TableCellComponent)(i0.ɵɵdirectiveInject(CellService), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver));
  };
  TableCellComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TableCellComponent,
    selectors: [["mdt-table-cell"]],
    viewQuery: function TableCellComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(CellDirective, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cellHost = _t.first);
      }
    },
    inputs: {
      row: "row",
      column: "column"
    },
    standalone: false,
    decls: 1,
    vars: 0,
    consts: [["mdtCellHost", ""]],
    template: function TableCellComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, TableCellComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
      }
    },
    dependencies: [CellDirective],
    encapsulation: 2
  });
  return TableCellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicTableComponent = /*#__PURE__*/(() => {
  class DynamicTableComponent {
    constructor(columnFilterService, dialog) {
      this.columnFilterService = columnFilterService;
      this.dialog = dialog;
      this.pageSize = 20;
      this.pageSizeOptions = [20, 50, 100];
      this.showFilters = true;
      this.stickyHeader = false;
      this.rowClick = new EventEmitter();
      this.appliedFilters = {};
    }
    ngOnInit() {
      if (this.dataSource == null) {
        throw Error('DynamicTable must be provided with data source.');
      }
      if (this.columns == null) {
        throw Error('DynamicTable must be provided with column definitions.');
      }
      if (this.paginator === undefined) {
        this.paginator = this.internalPaginator;
      }
      this.columns.forEach((column, index) => column.name = this.prepareColumnName(column.name, index));
      this.displayedColumns = this.columns.map((column, index) => column.name);
      const dataSource = this.dataSource;
      dataSource.sort = this.sort;
      dataSource.paginator = this.paginator;
    }
    isUsingInternalPaginator() {
      return this.paginator === this.internalPaginator;
    }
    canFilter(column) {
      const filter = this.columnFilterService.getFilter(column.type);
      return filter != null;
    }
    isFiltered(column) {
      return this.appliedFilters[column.name];
    }
    getFilterDescription(column) {
      const filter = this.appliedFilters[column.name];
      if (!filter || !filter.getDescription) {
        return null;
      }
      return filter.getDescription();
    }
    prepareColumnName(name, columnNumber) {
      return name || 'col' + columnNumber;
    }
    filter(column) {
      const filter = this.columnFilterService.getFilter(column.type);
      if (filter) {
        const dialogConfig = new MatDialogConfig();
        const columnFilter = new ColumnFilter();
        columnFilter.column = column;
        if (this.appliedFilters[column.name]) {
          columnFilter.filter = Object.create(this.appliedFilters[column.name]);
        }
        dialogConfig.data = columnFilter;
        const dialogRef = this.dialog.open(filter, dialogConfig);
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.appliedFilters[column.name] = result;
          } else if (result === '') {
            delete this.appliedFilters[column.name];
          }
          if (result || result === '') {
            this.updateDataSource();
          }
        });
      }
    }
    clearFilters() {
      this.appliedFilters = {};
      this.updateDataSource();
    }
    updateDataSource() {
      const dataSource = this.dataSource;
      dataSource.filters = this.getFilters();
    }
    getFilters() {
      const filters = this.appliedFilters;
      const filterArray = Object.keys(filters).map(key => filters[key]);
      return filterArray;
    }
    getFilter(columnName) {
      const filterColumn = this.getColumnByName(columnName);
      if (!filterColumn) {
        throw Error(`Column with name '${columnName}' does not exist.`);
      }
      return this.appliedFilters[filterColumn.name];
    }
    setFilter(columnName, filter) {
      const filterColumn = this.getColumnByName(columnName);
      if (!filterColumn) {
        throw Error(`Cannot set filter for a column. Column with name '${columnName}' does not exist.`);
      }
      this.appliedFilters[filterColumn.name] = filter;
      this.updateDataSource();
    }
    getColumnByName(columnName) {
      return this.columns.find(c => (c.name ? c.name.toLowerCase() : c.name) === (columnName ? columnName.toLowerCase() : columnName));
    }
    onRowClick(row) {
      this.rowClick.next(row);
    }
  }
  /** @nocollapse */
  /** @nocollapse */DynamicTableComponent.ɵfac = function DynamicTableComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DynamicTableComponent)(i0.ɵɵdirectiveInject(ColumnFilterService), i0.ɵɵdirectiveInject(i2.MatDialog));
  };
  DynamicTableComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DynamicTableComponent,
    selectors: [["mdt-dynamic-table"]],
    viewQuery: function DynamicTableComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(MatSort, 7);
        i0.ɵɵviewQuery(MatPaginator, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.internalPaginator = _t.first);
      }
    },
    inputs: {
      columns: "columns",
      dataSource: "dataSource",
      pageSize: "pageSize",
      pageSizeOptions: "pageSizeOptions",
      showFilters: "showFilters",
      stickyHeader: "stickyHeader",
      paginator: "paginator"
    },
    outputs: {
      rowClick: "rowClick"
    },
    standalone: false,
    decls: 5,
    vars: 10,
    consts: [["mat-table", "", "matSort", "", "matSortDirection", "asc", 3, "dataSource"], [3, "matColumnDef", "sticky", "stickyEnd", 4, "ngFor", "ngForOf"], ["mat-header-row", "", 4, "matHeaderRowDef", "matHeaderRowDefSticky"], ["mat-row", "", 3, "click", 4, "matRowDef", "matRowDefColumns"], [3, "hidden", "pageSize", "pageSizeOptions"], [3, "matColumnDef", "sticky", "stickyEnd"], ["mat-header-cell", "", 3, "mat-sort-header", "disabled", 4, "matHeaderCellDef"], ["mat-cell", "", 4, "matCellDef"], ["mat-header-cell", "", 3, "mat-sort-header", "disabled"], ["class", "mat-sort-header-button", 3, "matTooltip", "matTooltipDisabled", "click", 4, "ngIf"], [1, "mat-sort-header-button", 3, "click", "matTooltip", "matTooltipDisabled"], [3, "color"], ["mat-cell", ""], [3, "row", "column"], ["mat-header-row", ""], ["mat-row", "", 3, "click"]],
    template: function DynamicTableComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "table", 0);
        i0.ɵɵtemplate(1, DynamicTableComponent_ng_container_1_Template, 3, 3, "ng-container", 1)(2, DynamicTableComponent_tr_2_Template, 1, 0, "tr", 2)(3, DynamicTableComponent_tr_3_Template, 1, 0, "tr", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "mat-paginator", 4);
      }
      if (rf & 2) {
        i0.ɵɵproperty("dataSource", ctx.dataSource);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.columns);
        i0.ɵɵadvance();
        i0.ɵɵproperty("matHeaderRowDef", ctx.displayedColumns)("matHeaderRowDefSticky", i0.ɵɵpureFunction1(8, _c0, ctx.stickyHeader));
        i0.ɵɵadvance();
        i0.ɵɵproperty("matRowDefColumns", ctx.displayedColumns);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", !ctx.isUsingInternalPaginator())("pageSize", ctx.pageSize)("pageSizeOptions", ctx.pageSizeOptions);
      }
    },
    dependencies: [i3.NgForOf, i3.NgIf, i4.MatTable, i4.MatHeaderCellDef, i4.MatHeaderRowDef, i4.MatColumnDef, i4.MatCellDef, i4.MatRowDef, i4.MatHeaderCell, i4.MatCell, i4.MatHeaderRow, i4.MatRow, i5.MatSort, i5.MatSortHeader, i6.MatPaginator, i7.MatIcon, i8.MatTooltip, TableCellComponent],
    styles: ["table[_ngcontent-%COMP%]{width:100%}th[_ngcontent-%COMP%]   .mat-icon.mat-default[_ngcontent-%COMP%]{opacity:.54}th[_ngcontent-%COMP%]   .mat-icon.mat-default[_ngcontent-%COMP%]:hover{opacity:1}[hidden][_ngcontent-%COMP%]{display:none}button.mat-sort-header-button[_ngcontent-%COMP%]{border:none;background:0 0;display:flex;align-items:center;padding:0;cursor:inherit;outline:0;font:inherit;color:currentColor;position:relative}"]
  });
  return DynamicTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DateCellComponent = /*#__PURE__*/(() => {
  class DateCellComponent {
    constructor() {
      this.dateFormat = 'short';
    }
    ngOnInit() {
      if (this.column.options) {
        if (this.column.options.dateFormat) {
          this.dateFormat = this.column.options.dateFormat;
        }
      }
    }
  }
  /** @nocollapse */
  /** @nocollapse */DateCellComponent.ɵfac = function DateCellComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DateCellComponent)();
  };
  DateCellComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DateCellComponent,
    selectors: [["mdt-date-cell"]],
    inputs: {
      column: "column",
      row: "row"
    },
    standalone: false,
    decls: 2,
    vars: 4,
    template: function DateCellComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtext(0);
        i0.ɵɵpipe(1, "date");
      }
      if (rf & 2) {
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(1, 1, ctx.row[ctx.column.name], ctx.dateFormat));
      }
    },
    dependencies: [i3.DatePipe],
    encapsulation: 2
  });
  return DateCellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicTableModule = /*#__PURE__*/(() => {
  class DynamicTableModule {
    constructor(cellService) {
      this.cellService = cellService;
      cellService.registerCell('string', TextCellComponent);
      cellService.registerCell('date', DateCellComponent);
    }
  }
  /** @nocollapse */
  /** @nocollapse */

  /** @nocollapse */DynamicTableModule.ɵfac = function DynamicTableModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DynamicTableModule)(i0.ɵɵinject(CellService));
  };
  DynamicTableModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DynamicTableModule
  });
  DynamicTableModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [CellService, ColumnFilterService],
    imports: [CommonModule, MatTableModule, MatSortModule, MatPaginatorModule, MatIconModule, MatDialogModule, MatTooltipModule]
  });
  return DynamicTableModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of dynamic-table
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CellDirective, CellService, ColumnConfig, ColumnFilter, ColumnFilterService, DynamicTableComponent, DynamicTableModule };
